var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVerify({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333984 7.50016C0.333984 3.81826 3.31875 0.833496 7.00065 0.833496C10.6825 0.833496 13.6673 3.81826 13.6673 7.50016C13.6673 11.182 10.6825 14.1668 7.00065 14.1668C3.31875 14.1668 0.333984 11.182 0.333984 7.50016ZM9.71765 4.78829C10.0188 5.00018 10.0911 5.41605 9.87918 5.71716L6.71252 10.2172C6.59605 10.3826 6.41078 10.4863 6.20885 10.4989C6.00685 10.5115 5.81012 10.4317 5.67405 10.282L4.00736 8.44863C3.75968 8.17616 3.77976 7.75456 4.0522 7.5069C4.32464 7.25923 4.74627 7.2793 4.99394 7.5517L6.10092 8.76943L8.78878 4.94984C9.00065 4.64872 9.41652 4.5764 9.71765 4.78829Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerify);
export default __webpack_public_path__ + "static/media/icon-verify.f5db4589754af2a787176694d5f23aa0.svg";
export { ForwardRef as ReactComponent };